import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex items-center justify-center py-2 px-3 mx-auto bg-yellow-50 border border-yellow-100 rounded-md w-auto"},[_c(VIcon,{staticClass:"mr-2",attrs:{"color":"warning","size":"20"}},[_vm._v("mdi-alert-circle")]),_c('span',{staticClass:"text-sm"},[_vm._v("Job is invoiced. Please use \"Mail\" section if you need to add information.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }